'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

exports.default = createTrackers;

var _tracker = require('../redux/middlewares/tracker');

var _tracker2 = _interopRequireDefault(_tracker);

var _track = require('../redux/actions/track');

var actions = _interopRequireWildcard(_track);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultTrackerIds = function defaultTrackerIds(trackers, trackerType) {
    return (0, _keys2.default)(trackers && (trackers[trackerType] || []));
};

function createTrackers() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
        trackers = _ref.trackers,
        _ref$onSuccess = _ref.onSuccess,
        onSuccess = _ref$onSuccess === undefined ? function () {} : _ref$onSuccess,
        _ref$onError = _ref.onError,
        onError = _ref$onError === undefined ? function () {} : _ref$onError;

    return {
        track: function track(params, trackerType) {
            var trackerIds = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultTrackerIds(trackers, trackerType);

            var trackersComplete = trackerIds.map(function (trackerId) {
                var tracker = trackers[trackerType][trackerId];

                return tracker.track(params).then(function (_ref2) {
                    var response = _ref2.response;

                    onSuccess(response, params, trackerType, trackerId);
                    return { response: response, params: params, trackerType: trackerType, trackerId: trackerId };
                }).catch(function (error) {
                    onError(error, params, trackerType, trackerId);
                    return { response: error, params: params, trackerType: trackerType, trackerId: trackerId };
                });
            });

            return _promise2.default.all(trackersComplete);
        },


        middleware: (0, _tracker2.default)({ trackers: trackers, onSuccess: onSuccess, onError: onError }),
        actions: actions
    };
}
//# sourceMappingURL=create-trackers.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ui-core-navigation/~/@spp/tracking/lib/cjs/trackers/create-trackers.js
 ** module id = 628
 ** module chunks = 1
 **/